export const KanbanColorPicker = [
  '#C62828',
  '#AD1457',
  '#6A1B9A',
  '#4527A0',
  '#283593',
  '#1565C0',
  '#0282CC',
  '#00838F',
  '#38D9A9',
  '#40AB46',
  '#A5D8A7',
  '#CAD73B',
  '#FAB23E',
  '#FF8F00',
  '#EF6C00',
  '#D84315',
  '#FFFFFF',
];
